import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "chart-big",
  "use": "chart-big-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"chart-big\">\n  <path fill-rule=\"evenodd\" d=\"M260.5,322h-29a1.5,1.5,0,0,1,0-3h29A1.5,1.5,0,0,1,260.5,322Zm-1.5-6h-4a2,2,0,0,1-2-2V292a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v22A2,2,0,0,1,259,316Zm-1-23h-2v20h2V293Zm-10,23h-4a2,2,0,0,1-2-2V300a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v14A2,2,0,0,1,248,316Zm-1-15h-2v12h2V301Zm-10,15h-4a2,2,0,0,1-2-2v-6a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v6A2,2,0,0,1,237,316Zm-1-7h-2v4h2v-4Z\" transform=\"translate(-230 -290)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/chart-big.svg
// module id = null
// module chunks = 